import { useMemo } from "react";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import SanitizeHtml from "components/SanitizeHtml";
import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import PrintableFieldTitle from "pages/PrintableChecklist/components/PrintableFieldTitle";

import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";

export interface IPrintableRichtextfield {
  field: IField;
}

const PrintableRichtextfield = ({ field }: IPrintableRichtextfield) => {
  const value = useMemo(
    () => _.get(field.custom_values, "[0].rich_value"),
    [field.custom_values]
  );

  const showMissingTag = useMemo(() => _.isNil(value) || value === "", [value]);

  return (
    <>
      <Stack
        id={field.field_id.toString()}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
        sx={{
          padding: theme.spacing(0.5),
          borderBottom: `1px solid ${colors.blue20}`,
          backgroundColor: "initial",
        }}
      >
        <PrintableFieldTitle field={field} />
        <Stack
          direction="row"
          spacing={1}
          alignSelf="center"
          sx={{ flexGrow: 0 }}
          paddingTop={0.5}
        >
          {field.status === EFieldStatus.NA ? (
            <Text sx={{ color: colors.gray60 }}>N/A</Text>
          ) : (
            <>{showMissingTag && <Tag label="missing" variant="red" />}</>
          )}
        </Stack>
      </Stack>
      {value && field.status !== EFieldStatus.NA && (
        <Box sx={{ paddingLeft: theme.spacing(6) }}>
          <Box
            sx={{
              flex: 1,
              borderRadius: theme.spacing(0.5),
              border: `1px solid ${colors.blue20}`,
              padding: theme.spacing(1, 1.5, 1),
              marginY: theme.spacing(3),
              backgroundColor: colors.blue5,
              "@media print": {
                "*": { lineHeight: "140% !important" },
                table: {
                  width: "100%",
                },
                "table, th, td, tr": {
                  borderCollapse: "collapse",
                  border: "1px solid black !important",
                },
              },
            }}
          >
            <SanitizeHtml html={value} />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PrintableRichtextfield;
